import * as msal from '@azure/msal-browser';
import Routes, { ROUTE_TYPE } from 'rde-view-common/constants/Routes';
import { isNull, isUndefined, isEmpty } from 'rde-view-common/scripts/functions';
import routeConfig from '~/config/routeConfig';

const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const msedge = ua.indexOf('Edge/');
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

let accountId = '';
let tokenRequest = null;

let myMSALObj;
let config;

/**
 * Azure認証を行うmiddleware
 *
 * @param context nuxt context
 * @returns {Promise<void>}
 */
export default async function(context) {
  if (context.route.path === Routes.COMMON_ERROR.path) return;

  config = context.$config;
  if (config.securityDisabled) {
    console.log('securityDisabled');
    return;
  }

  try {
    if (isUndefined(myMSALObj)) {
      const routeKey = routeConfig.ME === ROUTE_TYPE.ENTRIES
        ? Object.keys(config.viewBaseUrl)
          .find(key => config.viewBaseUrl[key].startsWith(location.origin))
        : routeConfig.ME;
      const msalConfig = {
        auth: {
          clientId: config.b2c.clientId,
          authority: config.b2cCommon.authorities.signUpSignIn.authority,
          knownAuthorities: [config.b2cCommon.authorityDomain],
          redirectUri: config.viewBaseUrl[routeKey],
          postLogoutRedirectUri: config.b2cCommon.postLogoutRedirectUri
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: isIE || isEdge
        },
        system: {
          allowRedirectInIframe: true
        }
      };
      console.log('msalConfig: ', msalConfig);
      myMSALObj = new msal.PublicClientApplication(msalConfig);
    }
    await handleResponse(await myMSALObj.handleRedirectPromise());
    if (isNull(tokenRequest)) {
      tokenRequest = {
        scopes: [...config.b2c.b2cScopes],
        forceRefresh: false
      };
    }
  } catch (err) {
    console.error(err);
    await logoutSilent().catch(e => console.error(e));
    await context.redirect('/error');
  }
}

async function handleResponse(resp) {
  console.log('auth#handleResponse: ', resp);
  if (resp !== null) {
    accountId = resp.account.homeAccountId;
    myMSALObj.setActiveAccount(resp.account);
  } else {
    // need to call getAccount here?
    const currentAccounts = myMSALObj.getAllAccounts();
    console.log('currentAccounts: ', currentAccounts);
    if (!currentAccounts || currentAccounts.length < 1) {
      console.log('!currentAccounts || currentAccounts.length < 1');
      await signIn();
    } else if (currentAccounts.length > 1) {
      console.log('currentAccounts.length > 1');
    } else if (currentAccounts.length === 1) {
      console.log('currentAccounts.length === 1');
      const activeAccount = currentAccounts[0];
      myMSALObj.setActiveAccount(activeAccount);
      accountId = activeAccount.homeAccountId;
      console.log('active account: ', activeAccount);
    }
  }
}

async function signIn() {
  const loginRequest = {
    scopes: ['openid', ...config.b2c.b2cScopes]
  };
  return await myMSALObj.loginRedirect(loginRequest).catch((e) => console.error(e));
}

export function signOut() {
  const logoutRequest = {
    account: myMSALObj.getAccountByHomeId(accountId)
  };
  const accountIdAll = myMSALObj.getAllAccounts();
  console.log(accountIdAll);
  myMSALObj.logoutRedirect(logoutRequest);
}

export function logoutSilent() {
  return myMSALObj?.logout({ onRedirectNavigate: (url) => false });
}

export async function getApiToken() {
  return await getTokenRedirect(tokenRequest);
}

async function getTokenRedirect(request) {
  request.account = myMSALObj.getAccountByHomeId(accountId);
  if (isEmpty(request.account)) {
    await signIn();
  }
  const response = await myMSALObj.acquireTokenSilent(request);
  if (!response.accessToken || response.accessToken === '') {
    console.log('the response from B2C server has an empty accessToken field', response);
    console.error('the response from B2C server has an empty accessToken field');
  } else {
    return response.accessToken;
  }
}
